var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M446.171429 497.371429C321.828571 497.371429 219.428571 387.657143 219.428571 263.314286S321.828571 29.257143 453.485714 29.257143s234.057143 102.4 234.057143 234.057143-109.714286 234.057143-241.371428 234.057143z m0-409.6c-95.085714 0-175.542857 80.457143-175.542858 175.542857S351.085714 438.857143 446.171429 438.857143s175.542857-80.457143 175.542857-175.542857-73.142857-175.542857-175.542857-175.542857z",
    fill: "#09244B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.2 906.971429c0-241.371429-168.228571-431.542857-373.028571-431.542858S73.142857 665.6 73.142857 906.971429h746.057143z",
    fill: "#09244B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.2 928.914286H36.571429v-29.257143C36.571429 650.971429 219.428571 446.171429 438.857143 446.171429s402.285714 204.8 402.285714 453.485714v29.257143h-21.942857zM95.085714 877.714286h694.857143C782.628571 665.6 629.028571 504.685714 438.857143 504.685714c-182.857143 0-336.457143 160.914286-343.771429 373.028572z",
    fill: "#09244B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.914286 490.057143c-14.628571 0-21.942857-14.628571-21.942857-29.257143s7.314286-29.257143 21.942857-29.257143c73.142857 0 131.657143-58.514286 131.657143-138.971428 0-58.514286-36.571429-109.714286-95.085715-131.657143-7.314286 7.314286-14.628571-14.628571-7.314285-29.257143 0-14.628571 14.628571-21.942857 29.257142-14.628572 80.457143 21.942857 131.657143 95.085714 131.657143 182.857143 0 102.4-80.457143 190.171429-190.171428 190.171429z",
    fill: "#09244B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.8 833.828571h-65.828571c-14.628571 0-29.257143-14.628571-29.257143-29.257142s14.628571-29.257143 29.257143-29.257143h36.571428c-14.628571-160.914286-131.657143-285.257143-270.628571-285.257143-14.628571 0-29.257143-14.628571-29.257143-29.257143s7.314286-21.942857 21.942857-21.942857c182.857143 0 329.142857 168.228571 329.142857 373.028571v29.257143l-21.942857-7.314286z",
    fill: "#09244B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff);
export default __webpack_public_path__ + "static/media/staff.127286e380ec3b4d8c5a300886a14fd1.svg";
export { ForwardRef as ReactComponent };